import React, { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import FormDataContext from "integrations/contexts/FormDataContext";
import useFetch from "integrations/hooks/useFetch";
import urlWithAuthParams from "enterprise-integrations/helpers/urlWithAuthParams";
import { ApiRoutes } from "./common/Routes";
import formValidation from "./utils/formValidation";
import FormWrap from "../common/FormWrap";
import ValidatedInput from "../common/ValidatedInput";
import { renderOptions } from "../common/Options";
const StepAuthorize = ({ onSubmit, onChange }) => {
  var _a, _b, _c, _d;
  const { t } = useTranslation("enterprise_integrations");
  const { formData } = useContext(FormDataContext);
  const [formError, setFormError] = useState(null);
  const { clientSecret } = formData;
  const subscriptions = [
    { label: t("common.subscription.global_service"), value: "GLOBAL" },
    { label: t("common.subscription.us_government"), value: "US_GOV" },
    { label: t("common.subscription.us_dod"), value: "US_DOD" }
  ];
  const [DefenderValidationStatus, setDefenderValidation] = useFetch(
    null,
    onSubmit,
    "POST",
    {
      defender_tenant_id: ((_a = formData == null ? void 0 : formData.tenantId) == null ? void 0 : _a.value) || "",
      defender_client_id: ((_b = formData == null ? void 0 : formData.clientId) == null ? void 0 : _b.value) || "",
      defender_client_secret: ((_c = formData == null ? void 0 : formData.clientSecret) == null ? void 0 : _c.value) || "",
      defender_subscription_type: ((_d = formData == null ? void 0 : formData.subscriptionType) == null ? void 0 : _d.value) || ""
    },
    urlWithAuthParams
  );
  useEffect(() => {
    setDefenderValidation(null);
    if (DefenderValidationStatus.error) {
      setFormError({
        full_message: DefenderValidationStatus.error,
        nice_message: t("microsoftdefender.errors.unable_to_connect")
      });
    }
    return () => {
      setFormError(null);
    };
  }, [DefenderValidationStatus.error, setDefenderValidation, t]);
  const handleSubmit = () => {
    setDefenderValidation(ApiRoutes.INTEGRATIONS.Defender.CHECK_CREDENTIALS);
  };
  const isFormValid = formValidation.isFormValid(
    ["defenderName", "tenantId", "clientId", "clientSecret", "subscriptionType"],
    formData
  );
  return /* @__PURE__ */ React.createElement(
    FormWrap,
    {
      onSubmit: handleSubmit,
      buttonContent: t("common.buttons.verify_connection_and_proceed"),
      disabled: isFormValid,
      loading: DefenderValidationStatus.loading,
      title: "",
      error: formError,
      description: ""
    },
    /* @__PURE__ */ React.createElement(
      ValidatedInput,
      {
        className: "",
        id: "defenderName",
        type: "text",
        fieldData: formData.defenderName,
        onChange,
        placeholder: t("common.fields.input_name"),
        label: t("common.fields.input_name"),
        autoComplete: "off",
        help: t("common.fields.input_name_help"),
        defaultValue: clientSecret == null ? void 0 : clientSecret.value,
        required: true
      }
    ),
    /* @__PURE__ */ React.createElement(
      ValidatedInput,
      {
        className: "",
        id: "tenantId",
        type: "text",
        fieldData: formData.tenantId,
        onChange,
        label: t("microsoftdefender.authorize.tenant_id"),
        help: t("microsoftdefender.authorize.tenant_id_help"),
        autoComplete: "off",
        required: true
      }
    ),
    /* @__PURE__ */ React.createElement(
      ValidatedInput,
      {
        className: "",
        id: "clientId",
        type: "text",
        onChange,
        fieldData: formData.clientId,
        help: t("microsoftdefender.authorize.client_id_help"),
        label: t("microsoftdefender.authorize.client_id"),
        required: true
      }
    ),
    /* @__PURE__ */ React.createElement(
      ValidatedInput,
      {
        className: "",
        id: "clientSecret",
        type: "password",
        onChange,
        fieldData: formData.clientSecret,
        label: t("microsoftdefender.authorize.client_secret"),
        help: t("microsoftdefender.authorize.client_secret_help"),
        required: true
      }
    ),
    /* @__PURE__ */ React.createElement(
      ValidatedInput,
      {
        type: "select",
        name: "subscriptionType",
        id: "subscriptionType",
        onChange,
        fieldData: formData.subscriptionType,
        help: t("common.subscription.type_help"),
        required: true,
        label: t("common.subscription.type")
      },
      renderOptions(subscriptions, t("common.subscription.choose"))
    )
  );
};
export default StepAuthorize;
